import { Log } from '@core';
import { filter, first, Observable, of, switchMap, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { NotificationObserverQueryHandler } from '../../../../projects/notifications/src/lib/application/handlers';

export class ObserveNotificationStep extends StartupStep {
  private readonly notificationObserverQueryHandler: NotificationObserverQueryHandler = inject(
    NotificationObserverQueryHandler
  );

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'ObserveNotificationStep START' });
    state.authed$
      ?.pipe(
        filter(Boolean),
        first(),
        switchMap(() => this.notificationObserverQueryHandler.observeNotification()),
        tap(() => this.logger.log(Log.Startup, { message: 'ObserveNotificationStep COMPLETED' }))
      )
      .subscribe();

    return of(state);
  }
}
